import { EmailSubmissionResult } from '@intercom/gtm-js/dist/types/email_submission_result'
import { IResponse } from 'marketing-site/pages/api/forms/submit'
import { SizeOptions } from 'marketing-site/src/library/elements/Text'
import { AllSystemColors, Icon } from 'marketing-site/src/library/utils'
import { IProps as ICTALink } from '../../elements/CTALink'

export { MarketoFormV2 } from './component'

export const SIGNUP_INTENT = 'signup-intent'

export type IMarketoFormValues = Record<string, string>

export type IOnMarketoFormSubmit = (
  response: IResponse,
  values?: IMarketoFormValues,
  emailSubmissionResult?: EmailSubmissionResult | null,
) => void

export type IProps = {
  formId: number
  submitButtonLabel: string
  redirectUrl?: string
  headingText?: string
  headingSize?: SizeOptions
  subheadingText?: string
  subheadingSize?: SizeOptions
  backgroundColor?: AllSystemColors
  theme?: 'default' | 'rounded'
  hideLabels?: boolean
  forceBusinessEmail?: boolean
  emailSubmissionSource?: string
  onSubmit?: IOnMarketoFormSubmit
  hiddenFieldIds?: string[]
  defaults?: IMarketoFormValues
  icon?: Icon
  secondaryCTA?: ICTALink
}
